<tf-tag-editor [tags]="selectedTags()" [editable]="false" />
